/* unplugin-vue-components disabled */import { render } from "./App.vue?vue&type=template&id=633358ca"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=633358ca&lang=css"

import exportComponent from "E:\\Project\\basework.sitcph.appointment\\mobile\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__